import React, { createContext, useContext } from 'react';
import { useAppUpdate } from '@/hooks/useAppUpdate';

const AppUpdateContext = createContext<ReturnType<typeof useAppUpdate> | null>(null);

export const AppUpdateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useAppUpdate();
  return <AppUpdateContext.Provider value={value}>{children}</AppUpdateContext.Provider>;
};

export const useAppUpdateContext = () => {
  const ctx = useContext(AppUpdateContext);
  if (!ctx) throw new Error('useAppUpdateContext must be used within AppUpdateProvider');
  return ctx;
};
